import React, { useEffect } from 'react';
import { SectionManagementForm } from './SectionManagementForm';
import { Section } from '../../../store/sections/types';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ISectionsState } from '../../../store/sections/store';
import { StoreState } from '../../../store/store';
import {
  fetchSectionDetail,
  updateSection,
} from '../../../store/sections/actions';
import { SectionListRoute } from '../../../routes/routes';
import { isValidResponse } from '../../../services/responseService';
import { useToast } from '../../../hooks/useToast';
import { useTranslation } from 'react-i18next';

export interface ISectionManagementEditRouteParams {
  industry: string;
  portalName: string;
  webSectionDisplayName: string;
}

interface ISectionManagementEditProps {}

export const SectionManagementEditForm: React.FunctionComponent<ISectionManagementEditProps> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { addToast } = useToast();
  const { t } = useTranslation();
  const routeParams = useParams<ISectionManagementEditRouteParams>();
  const sectionsState = useSelector<StoreState, ISectionsState>(
    (state) => state.sections
  );
  const {
    sectionDetail: sectionDetail,
    industryInfo,
    status,
    loading,
    commited,
    message,
  } = sectionsState;

  useEffect(() => {
    if (sectionsState.industryInfo.length > 0) {
      dispatch(
        fetchSectionDetail(
          routeParams.industry,
          routeParams.portalName,
          routeParams.webSectionDisplayName
        )
      );
    }
  }, [industryInfo]);

  useEffect(() => {
    const _isValidResponse = isValidResponse(status);
    if (loading == false && _isValidResponse) {
      if (commited) {
        const hasMessage = message != undefined && message !== '';
        const okMessage = t('Section_successfully_modified');
        addToast({
          status: hasMessage ? 'warning' : 'ok',
          message: hasMessage ? message! : okMessage,
        });
        history.push(SectionListRoute.path);
      } else {
        addToast({
          status: 'danger',
          message: message || `Error ${status}`,
        });
      }
    } else {
      if (status && status >= 400) {
        addToast({
          status: 'danger',
          message: message || `Error ${status}`,
        });
      }
    }
  }, [message, status]);

  const enableActionButtonCondition = (newSection: Section): boolean => {
    if (newSection.industry === '' || newSection.portalName === '') return true;
    if (
      newSection.webSectionName === '' ||
      newSection.webSectionDisplayName === '' ||
    //  newSection.webSectionURL === '' ||
     // newSection.powerBIReportName === '' ||
      //newSection.powerBIReportDefaultPage === '' ||
      newSection.userWebFeatureGrant === '' ||
      newSection.webSectionDisplayName === ''
    )
      return true;
    return false;
  };

  const editSectionClick = (newSection: Section) => {
    dispatch(updateSection(newSection));
  };

  return (
    <SectionManagementForm
      existingSection={sectionDetail}
      actionButtonClick={editSectionClick}
      actionButtonText={t('Edit_Section')}
      editMode={true}
      enableActionButtonCondition={enableActionButtonCondition}
    />
  );
};
